/**
 * @generated SignedSource<<5dd6cd64255fbbc94318dac90d5476b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateKitInput = {
  clientMutationId?: string | null | undefined;
  dailyRate?: number | null | undefined;
  description: string;
  memberTags?: ReadonlyArray<any> | null | undefined;
  notes?: string | null | undefined;
  rentable?: boolean | null | undefined;
};
export type OpsKitNewPageCreateMutation$variables = {
  input: CreateKitInput;
};
export type OpsKitNewPageCreateMutation$data = {
  readonly createKit: {
    readonly kit: {
      readonly assetTag: any;
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsKitNewPageCreateMutation = {
  response: OpsKitNewPageCreateMutation$data;
  variables: OpsKitNewPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateKitPayload",
    "kind": "LinkedField",
    "name": "createKit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "kit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsKitNewPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsKitNewPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8271560c3bc9608b30613e4a73f0fc4",
    "id": null,
    "metadata": {},
    "name": "OpsKitNewPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsKitNewPageCreateMutation(\n  $input: CreateKitInput!\n) {\n  createKit(input: $input) {\n    kit {\n      id\n      assetTag\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c865b283c878e8020709ddad07be71c";

export default node;
